import { JSX } from "react";
import { useNavigate } from "react-router";
import { TableWidget } from "@hatch-digital-nl/abs-storybook/legacy";
import Skeleton from "react-loading-skeleton";
import historyImage from "../../../../common/images/history.svg";
import { RouteEnum } from "../../../../common/enums/RouteEnum";
import { useDashboardExpiringSoonCertificates } from "../../hooks/useDashboardExpiringSoonCertificates";

export const DashboardExpiringSoonCertificates = (): JSX.Element => {
    const navigate = useNavigate();
    const {
        loading,
        table,
        currentPage,
        itemsPerPage,
        itemsPerPageSelect,
        onPageChange,
        onItemsPerPageChange,
        title,
        emptyResultText,
    } = useDashboardExpiringSoonCertificates();

    if (loading) {
        return <Skeleton height={"35rem"} borderRadius={"1.5rem"} />;
    }

    return (
        <TableWidget
            data={table}
            showResultCount={true}
            totalItemsInTitle={false}
            svgUrl={historyImage}
            title={title}
            currentPage={currentPage}
            onChange={onPageChange}
            itemsPerPage={itemsPerPage}
            itemsPerPageSelect={itemsPerPageSelect}
            onItemsPerPageChange={onItemsPerPageChange}
            lastColumnAlignRight
            emptyResultText={emptyResultText}
            onTitleClick={() => navigate(RouteEnum.CERTIFICATE_EXPIRY)}
        />
    );
};
